import React from 'react';
import ReactDOM from 'react-dom';

import './style/default.css';

import App from './components/App';


const root = document.getElementById('root');
const data = document.getElementById('prerender-data');
const initialNews = data ? JSON.parse(data.textContent).news : undefined;
const app = <React.StrictMode><App initialNews={initialNews} /></React.StrictMode>;
if (root.hasChildNodes()) {
  ReactDOM.hydrate(app, root);
} else {
  ReactDOM.render(app, root);
}
